<template>
  <router-view></router-view>
</template>

<script>
import Vue from "vue";
import VueNativeSock from "vue-native-websocket";
import config from "@/config/config";

//Highchats plugin
import HighchartsVue from "highcharts-vue";
import Highcharts from "highcharts";
import dataInit from "highcharts/modules/data";
import exportingInit from "highcharts/modules/exporting";
import exportDataInit from "highcharts/modules/export-data";
import highchartsMoreInit from "highcharts/highcharts-more";
import stockInit from "highcharts/modules/stock";
import xrangeInit from "highcharts/modules/xrange";
import drilldownInit from "highcharts/modules/drilldown";
import boostInit from "highcharts/modules/boost";
import noDataToDisplayInit from "highcharts/modules/no-data-to-display";

exportingInit(Highcharts);
exportDataInit(Highcharts);
dataInit(Highcharts);
highchartsMoreInit(Highcharts);
stockInit(Highcharts);
xrangeInit(Highcharts);
drilldownInit(Highcharts);
boostInit(Highcharts);
noDataToDisplayInit(Highcharts);
Vue.use(HighchartsVue);

export default {
  data() {
    return {
      reconnect: true,
      reconnectAttempts: 0
    };
  },

  computed: {
    isConnected() {
      return this.$store.getters.isConnected;
    }
  },

  created() {
    if (this.$route.query.lang){
      if (this.$route.query.lang === "en"){
        this.$lang.setLang("en");
      } else if (this.$route.query.lang === "sk"){
        this.$lang.setLang("sk");
      } else if (this.$route.query.lang === "de"){
        this.$lang.setLang("de");
      }
    } else {
      //DEFAULT
      this.$lang.setLang("en");
    }
    

    Vue.use(VueNativeSock, this.$ENDPOINTS.API_WS, {
      connectManually: true
    });

    Vue.prototype.$connect(this.$ENDPOINTS.API_WS);
    Vue.prototype.$socket.onopen = this.onOpenWS;
    Vue.prototype.$socket.onclose = this.onWSClose;
    Vue.prototype.$socket.onmessage = this.onMessage;
  },

  mounted() {
    Highcharts.setOptions({
      lang: {
        viewFullscreen: this.$lang.charts.viewFullscreen,
        printChart: this.$lang.charts.printChart,
        downloadPNG: this.$lang.charts.downloadPNG,
        downloadJPEG: this.$lang.charts.downloadJPEG,
        downloadPDF: this.$lang.charts.downloadPDF,
        downloadSVG: this.$lang.charts.downloadSVG,
        downloadCSV: this.$lang.charts.downloadCSV,
        downloadXLS: this.$lang.charts.downloadXLS,
        viewData: this.$lang.charts.viewData,
        openInCloud: this.$lang.charts.openInCloud,
        contextButtonTitle: this.$lang.charts.contextButtonTitle,
        resetZoom: this.$lang.charts.resetZoom,
        loading: this.$lang.charts.loading,
        weekdays: this.$lang.charts.weekdays,
        months: this.$lang.charts.months,
        shortMonths: this.$lang.charts.shortMonths,
        scalerChange: this.$lang.charts.scaleChange,
        drillUpText: this.$lang.charts.drillUpText,
        noData: this.$lang.charts.noData
      }
    });
  },

  methods: {
    onMessage: function(data) {
      try {
        const wsMessage = JSON.parse(data.data);
        //console.log("WS msg: ", wsMessage);

        if (wsMessage.status === "FAIL") {
          this.reconnect = false;
          console.log("WebSocket error code: ", wsMessage.code);

          switch (wsMessage.code) {
            case 714:
            case 722:
              console.log("Token expired");
              break;
            case 716:
            case 720:
              console.log("Token ?");
              break;
          }
        } else {
          if (wsMessage.topic === "Data") {
            this.$store.commit("setDataMessage", wsMessage);
          } else if (wsMessage.topic == "Notification") {
            this.$store.commit(
              "setNotificationList",
              JSON.parse(wsMessage.data)
            );
          }
        }
      } catch (err) {
        console.log("Error parsing message from WS");
        console.log(err);
      }
    },

    notificationSubscribe: function() {
      const subscribeNotification = {
        deviceToken: this.$route.query.token,
        notification: true,
        data: true
      };
      //console.log("Notification subscribe: ", subscribeNotification);
      Vue.prototype.$socket.send(JSON.stringify(subscribeNotification));
    },

    onOpenWS: function() {
      this.$store.commit("setConnected", true);
      this.notificationSubscribe();
    },

    onWSClose() {
      Vue.prototype.$disconnect();
      this.$store.commit("setConnected", false);
      if (this.reconnect) {
        this.WSReconnect();
      }
    },

    WSReconnect() {
      if (!this.isConnected) {
        if (this.reconnectAttempts < config.websocket.reconnectAttempts) {
          Vue.prototype.$connect(this.$ENDPOINTS.API_WS);
          Vue.prototype.$socket.onopen = this.onOpenWS;
          Vue.prototype.$socket.onclose = this.onWSClose;
          Vue.prototype.$socket.onmessage = this.onMessage;

          this.reconnectAttempts++;
        }
      }
    }
  },

  beforeDestroy() {
    this.$store.commit("setConnected", false);
    this.reconnect = false;
    Vue.prototype.$disconnect();
    delete Vue.prototype.$socket;
  }
};
</script>
